import { DispositiveProvisions_DispositiveProvisionFragment } from '../graphql/DispositiveProvisions.fragments.generated';

export function sortDispositiveProvisions(
  a: DispositiveProvisions_DispositiveProvisionFragment,
  b: DispositiveProvisions_DispositiveProvisionFragment
) {
  return a.dispositionOrder - b.dispositionOrder;
}
